// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".basedata-container[data-v-dafe2b98] {\n  padding: 0.052083rem;\n}", "",{"version":3,"sources":["D:/source/200xth/xth2.web/<input css 41>"],"names":[],"mappings":"AAAA;EACE,oBAAoB;AACtB","file":"BaseData.vue","sourcesContent":[".basedata-container {\n  padding: 0.052083rem;\n}"]}]);
// Exports
module.exports = exports;
